import technical from '../../../assets/images/match__technical.webp';
import between from '../../../assets/images/match__between.webp';
import pre from '../../../assets/images/match__pre-match.webp';
import './match.scss';
import { useTranslation } from 'react-i18next';

const Match: React.FC = () => {
    const { t } = useTranslation();
    return (
        <section className="match">
            <h2 className='match__header'>{t("match_support.title")}</h2>
            <div className="match__preparation">
                <div className="match__preparation-technical match__preparation-item">
                    <img src={technical} alt="icon ball" className="icon" />
                    <h3>{t("match_support.sections.technical_maintenance.title")}</h3>
                    <ul>
                        <li>- {t("match_support.sections.technical_maintenance.items.item1")};</li>
                        <li>- {t("match_support.sections.technical_maintenance.items.item2")};</li>
                        <li>- {t("match_support.sections.technical_maintenance.items.item3")};</li>
                        <li>- {t("match_support.sections.technical_maintenance.items.item4")};</li>
                        <li>- {t("match_support.sections.technical_maintenance.items.item5")};</li>
                        <li>- {t("match_support.sections.technical_maintenance.items.item6")};</li>
                        <li>- {t("match_support.sections.technical_maintenance.items.item7")};</li>
                        <li>- {t("match_support.sections.technical_maintenance.items.item8")};</li>
                        <li>- {t("match_support.sections.technical_maintenance.items.item9")};</li>
                        <li>- {t("match_support.sections.technical_maintenance.items.item10")};</li>
                        <li>- {t("match_support.sections.technical_maintenance.items.item11")};</li>
                        <li>- {t("match_support.sections.technical_maintenance.items.item12")};</li>
                        <li>- {t("match_support.sections.technical_maintenance.items.item13")};</li>
                        <li>- {t("match_support.sections.technical_maintenance.items.item14")};</li>
                        <li>- {t("match_support.sections.technical_maintenance.items.item15")};</li>

                    </ul>
                </div>
                <div className="match__preparation-between match__preparation-item">
                    <img src={between} alt="icon ball" className="icon" />
                    <h3>{t("match_support.sections.between_match_preparation.title")}</h3>
                    <ul>
                        <li>- {t("match_support.sections.between_match_preparation.items.item1")};</li>
                        <li>- {t("match_support.sections.between_match_preparation.items.item2")};</li>
                        <li>- {t("match_support.sections.between_match_preparation.items.item3")};</li>
                        <li>- {t("match_support.sections.between_match_preparation.items.item4")};</li>
                        <li>- {t("match_support.sections.between_match_preparation.items.item5")};</li>
                        <li>- {t("match_support.sections.between_match_preparation.items.item6")};</li>
                        <li>- {t("match_support.sections.between_match_preparation.items.item7")};</li>
                        <li>- {t("match_support.sections.between_match_preparation.items.item8")};</li>
                        <li>- {t("match_support.sections.between_match_preparation.items.item9")};</li>
                        <li>- {t("match_support.sections.between_match_preparation.items.item10")};</li>
                        <li>- {t("match_support.sections.between_match_preparation.items.item11")};</li>
                        <li>- {t("match_support.sections.between_match_preparation.items.item12")};</li>

                    </ul>
                </div>
                <div className="match__preparation-pre match__preparation-item">
                    <img src={pre} alt="icon foot" className="icon" />
                    <h3>{t("match_support.sections.pre_match_preparation.title")}</h3>
                    <ul>
                        <li>- {t("match_support.sections.pre_match_preparation.items.item1")};</li>
                        <li>- {t("match_support.sections.pre_match_preparation.items.item2")};</li>
                        <li>- {t("match_support.sections.pre_match_preparation.items.item3")};</li>
                        <li>- {t("match_support.sections.pre_match_preparation.items.item4")};</li>
                        <li>- {t("match_support.sections.pre_match_preparation.items.item5")};</li>
                        <li>- {t("match_support.sections.pre_match_preparation.items.item6")};</li>
                        <li>- {t("match_support.sections.pre_match_preparation.items.item7")};</li>
                        <li>- {t("match_support.sections.pre_match_preparation.items.item8")};</li>
                        <li>- {t("match_support.sections.pre_match_preparation.items.item9")};</li>
                        <li>- {t("match_support.sections.pre_match_preparation.items.item10")};</li>
                    </ul>
                </div>
            </div>
        </section>

    )
}

export default Match;